import React from 'react';
import PropTypes from 'prop-types';
import { AButton } from './abutton';
import { getUtmSource } from '../utils/helpers';

export const ABookDemoBtn = ({
  type = 'primary',
  size = 'md',
  label = 'Book a demo',
  hideIcon = true,
  fullWidth,
  disabled,
}) => {
  return (
    <AButton
      href={`/book-demo/${getUtmSource()}`}
      // target="_blank"
      rel="noreferrer"
      type={type}
      size={size}
      hideIcon={hideIcon}
      fullWidth={fullWidth}
      disabled={disabled}
    >
      {label}
    </AButton>
  );
};

ABookDemoBtn.propTypes = {
  type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'quaternary']),
  size: PropTypes.oneOf(['lg', 'md', 'sm']),
  label: PropTypes.string,
  disabled: PropTypes.bool,
  hideIcon: PropTypes.bool,
  fullWidth: PropTypes.bool,
};
